import React from 'react';

interface ImageSvgProps {
  width?: number | string;
  height?: number | string;
}

const ImageIcon: React.FC<ImageSvgProps> = ({ width = 38, height = 38 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 5H5C3.93913 5 2.92172 5.42143 2.17157 6.17157C1.42143 6.92172 1 7.93913 1 9V29M33 17V25M33 25V33C33 34.0609 32.5786 35.0783 31.8284 35.8284C31.0783 36.5786 30.0609 37 29 37H5C3.93913 37 2.92172 36.5786 2.17157 35.8284C1.42143 35.0783 1 34.0609 1 33V29M33 25L29.828 21.828C29.0779 21.0781 28.0607 20.6569 27 20.6569C25.9393 20.6569 24.9221 21.0781 24.172 21.828L21 25M1 29L10.172 19.828C10.9221 19.0781 11.9393 18.6569 13 18.6569C14.0607 18.6569 15.0779 19.0781 15.828 19.828L21 25M21 25L25 29M29 5H37M33 1V9M21 13H21.02"
        stroke="#3477F5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ImageIcon;
